import { ChevronRight, ArrowLeft } from "lucide-react";
import type { CSSProperties } from "react";

interface BreadcrumbItem {
  label: string;
  onClick?: () => void;
}

interface AdminBreadcrumbProps {
  items: BreadcrumbItem[];
}

export function AdminBreadcrumb({ items }: AdminBreadcrumbProps) {
  return (
    <nav
      aria-label="Breadcrumb"
      style={{ display: "flex", alignItems: "center", gap: "0.375rem" }}
    >
      {items[0]?.onClick && (
        <button
          aria-label={`Voltar para ${items[0].label.toLowerCase()}`}
          onClick={items[0].onClick}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "var(--login-muted)",
            padding: "0.25rem",
            display: "flex",
            alignItems: "center",
            marginRight: "0.125rem",
          }}
        >
          <ArrowLeft aria-hidden="true" size={16} strokeWidth={1.75} />
        </button>
      )}
      {items.map((item, i) => {
        const style: CSSProperties = {
          fontFamily: "'Barlow Condensed', sans-serif",
          fontWeight: 600,
          fontSize: "0.875rem",
          letterSpacing: "0.04em",
          color: item.onClick ? "var(--login-accent)" : "var(--login-text)",
          background: "none",
          border: "none",
          cursor: item.onClick ? "pointer" : "default",
          padding: 0,
        };

        return (
          <div
            key={i}
            style={{ display: "flex", alignItems: "center", gap: "0.25rem" }}
          >
            {i > 0 && (
              <ChevronRight
                size={14}
                strokeWidth={1.5}
                style={{ color: "var(--login-muted)" }}
              />
            )}
            {item.onClick ? (
              <button onClick={item.onClick} style={style}>
                {item.label}
              </button>
            ) : (
              <span aria-current="page" style={style}>
                {item.label}
              </span>
            )}
          </div>
        );
      })}
    </nav>
  );
}
